// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useQuery } from "@tanstack/react-query";
import { HttpClientInstance, useHttpClient } from "@toggl/sync/http";
import {} from "../types";
import { createQueryOptions } from "../utils/queries";
import { getTestQueryKey } from "./keys";
import { getTest } from "./requests";

/**
 * Returns a test by the provided slug.
 */
export function getTestQueryOptions(
  httpClient: HttpClientInstance,
  job_opening_slug: string,
  slug: string,
  enabled?: boolean,
) {
  return createQueryOptions({
    queryKey: getTestQueryKey(job_opening_slug, slug),
    queryFn: ({ signal }) =>
      getTest(httpClient, job_opening_slug, slug, signal),
    enabled,
  });
}
/**
 * Returns a test by the provided slug.
 */
export function useGetTest(
  job_opening_slug: string,
  slug: string,
  enabled?: boolean,
) {
  const httpClient = useHttpClient();
  return useQuery(
    getTestQueryOptions(httpClient, job_opening_slug, slug, enabled),
  );
}
